module.exports = __webpack_public_path__ + "static/media/executives.5f61046f.jpg";